import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import { ManageService } from "../services/Services";

export const useGetSubAccountInfo = (platform, user) => {
    const [kycData, setKycData] = useState(null);
    const [isLoadingFetch, setIsLoadingFetch] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const fetchKycData = useCallback(async () => {
        setIsLoadingFetch(true);
        setErrorMessage(null);

        try {
            const kycDataResult = await ManageService.getCryptoSubAccountCryptofacil(platform);

            if (kycDataResult?.needLoad) {
                await ManageService.setZinliData({
                    email: user?.email,
                    phone: user?.phone,
                    idUsr: user?.idUsr,
                });
                const response = await refetch();
                return response;
            }

            if (!kycDataResult) {
                toast.error("KYC data not available");
                return null;
            }

            setKycData(kycDataResult);
            return kycDataResult;
        } catch (error) {
            toast.error(error?.message || String(error) || "Error fetching KYC data");
            setErrorMessage(error?.message || String(error) || "Error fetching KYC data");
        } finally {
            setIsLoadingFetch(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [platform, user]);

    const refetch = () => {
        const response = fetchKycData();
        return response;
    };

    useEffect(() => {
        fetchKycData();
    }, [fetchKycData]);

    return { kycData, isLoadingFetch, errorMessage, refetch };
};
